import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../components/Button';

import LoadingModal from '../../../components/LoadingModal';

import defaultStyles from '../../../styles/formSetStyles.module.css';
import styles from './index.module.css';

export const SignatureInput = ({
  initialSignature,
  onSubmit,
  pending,
}: {
  initialSignature: string;
  onSubmit: (signature: string) => void;
  pending?: boolean;
}) => {
  const [signature, setSignature] = useState(initialSignature);
  const { t } = useTranslation();

  let className = styles.SignatureInput;
  if (signature) {
    className = `${className} ${styles.SignatureInputCursive}`;
  }
  const label = t(
    'Type your full name on the line below to sign these documents.',
  );

  return (
    <div className={styles.SignerPage}>
      <LoadingModal isOpen={!!pending} />
      <div>
        <div className={defaultStyles.Label}>{label}</div>
      </div>

      <div className={styles.InputDiv}>
        <input
          type="text"
          value={signature}
          className={className}
          onChange={(e) => setSignature(e.currentTarget.value)}
          placeholder={t('Your full name')}
          autoFocus
        />
      </div>

      <div className={defaultStyles.ButtonSubmitWrapper}>
        <Button
          type="button"
          children={t('Submit Signature')}
          disabled={!signature || pending}
          onClick={() => {
            onSubmit(signature);
          }}
        />
      </div>
    </div>
  );
};
